import { render, staticRenderFns } from "./add-coupon.vue?vue&type=template&id=255e9eb0&"
import script from "./add-coupon.vue?vue&type=script&lang=js&"
export * from "./add-coupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports